import { request } from "../../utils/axios";

export const register = async (form: {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
}) => {
  try {
    const res = await request.post(`register`, { ...form, role_id: 2 });
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const login = async (form: { email: string; password: string }) => {
  try {
    const res = await request.post(`login`, form);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const forgotPassword = async (form: { email: string }) => {
  try {
    const res = await request.post(`forgot-password`, form);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const resetPassword = async (form: {
  token: string;
  new_password: string;
}) => {
  try {
    const res = await request.post(`reset-password`, form);
    return res?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};

export const validateToken = async (token: string) => {
  try {
    const res = await request.get(`validate-reset-token?token=${token}`);
    return res?.data?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};


export const validateEmailToken = async (token: string) => {
  try {
    const res = await request.get(`verify?token=${token}`);
    return res?.data?.data;
  } catch (error: any) {
    const err = error?.response?.data;
    throw err;
  }
};
